module.exports = __webpack_public_path__ + "img/mail.460e84b4.svg";